import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNewlineWithBr',
  standalone: false,
})
export class ReplaceNewlineWithBrPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/g, '<br>');
  }
}
